import React from 'react';

const ModalContext = React.createContext({ hide: () => {}, show: () => {} });
export default ModalContext;
